// extracted by mini-css-extract-plugin
export var deliveryRow = "_rl-a";
export var fixedHeight = "_rl-4";
export var freightLogo = "_rl-9";
export var fullWidth = "_rl-3";
export var priceColumn = "_rl-5";
export var radioSelected = "_rl-7";
export var radioUnselected = "_rl-6";
export var selectedOption = "_rl-2";
export var selectedOptionContainer = "_rl-1";
export var selection = "_rl-0";
export var tallSkeletonText = "_rl-8";